export default  {
  id: 'colorBands',
  beforeDraw(chart, _args, opts) {
    const bands = opts?.bands || [];
    const { ctx, chartArea, scales } = chart;
    if (!bands.length || !chartArea) return;

    ctx.save();
    // Clip to chart plotting area
    ctx.beginPath();
    ctx.rect(
      chartArea.left,
      chartArea.top,
      chartArea.right - chartArea.left,
      chartArea.bottom - chartArea.top
    );
    ctx.clip();

    bands.forEach(band => {
      if (band == null) return;
      const axisId = band.axis || 'y';
      const scale = scales[axisId];
      if (!scale) return;
      if (band.from == null || band.to == null) return;

      // Convert values to pixels
      const yA = scale.getPixelForValue(band.from);
      const yB = scale.getPixelForValue(band.to);

      // Normalize and clamp to chart area
      let top = Math.min(yA, yB);
      let bottom = Math.max(yA, yB);
      top = Math.max(chartArea.top, Math.min(top, chartArea.bottom));
      bottom = Math.max(chartArea.top, Math.min(bottom, chartArea.bottom));

      if (bottom <= top) return; // fully outside

      ctx.fillStyle = band.color || 'rgba(0,0,0,0.05)';
      ctx.fillRect(
        chartArea.left,
        top,
        chartArea.right - chartArea.left,
        bottom - top
      );
    });

    ctx.restore();
  }
};
